
import { Component, EventEmitter, Input, Output, OnInit, OnChanges, SimpleChanges  } from '@angular/core';
type RangeType = 'single' | 'dual';

@Component({
  selector: 'app-range-filter',
  templateUrl: './range-filter.component.html',
  styleUrls: ['./range-filter.component.scss']
})
export class RangeFilterComponent implements OnInit, OnChanges {

 @Input() type: RangeType = 'single';
  @Input() min = 0;
  @Input() max = 1000;
  @Input() step = 1;
  @Input() unit = ''; // e.g. ' miles', '£'

  // Single mode
  @Input() value?: number;
  @Output() valueChange = new EventEmitter<number>();

  // Dual mode
@Input() set minValue(v: number | undefined) {
  if (v !== undefined && v !== this.currentMin) {
    this.currentMin = Math.max(this.min, Math.min(v, this.currentMax - this.step));
    this.updatePercentages();
  }
}

@Input() set maxValue(v: number | undefined) {
  if (v !== undefined && v !== this.currentMax) {
    this.currentMax = Math.max(this.currentMin + this.step, Math.min(v, this.max));
    this.updatePercentages();
  }
}
  @Output() minValueChange = new EventEmitter<number>();
  @Output() maxValueChange = new EventEmitter<number>();
  @Output() rangeChange = new EventEmitter<{ min: number; max: number }>();

  // Live internal values — these drive the UI
  currentSingle = 0;
  currentMin = 0;
  currentMax = 1000;

  singlePercent = 0;
  minPercent = 0;
  maxPercent = 100;

  get isDual(): boolean {
    return this.type === 'dual';
  }

  ngOnInit() {
    if (this.isDual) {
      this.currentMin = Math.max(this.min, Math.min(this.minValue ?? this.min, this.max));
      this.currentMax = Math.max(this.currentMin, Math.min(this.maxValue ?? this.max, this.max));
    } else {
      this.currentSingle = Math.max(this.min, Math.min(this.value ?? this.min, this.max));
    }
    this.updatePercentages();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.isDual) {
      if (changes['minValue'] && this.minValue !== undefined) {
        this.currentMin = Math.max(this.min, Math.min(this.minValue, this.currentMax - this.step));
      }
      if (changes['maxValue'] && this.maxValue !== undefined) {
        this.currentMax = Math.max(this.currentMin + this.step, Math.min(this.maxValue, this.max));
      }
    } else {
      if (changes['value'] && this.value !== undefined) {
        this.currentSingle = Math.max(this.min, Math.min(this.value, this.max));
      }
    }

    this.updatePercentages();
  }

  // ── SINGLE MODE ────────────────────────────────────────
  onSingleDrag(event: Event): void {
    const val = Number((event.target as HTMLInputElement).value);
    this.currentSingle = val;
    this.valueChange.emit(val);
    this.updatePercentages();
  }

  // ── DUAL MODE ──────────────────────────────────────────
  onMinDrag(event: Event): void {
    let val = Number((event.target as HTMLInputElement).value);
    val = Math.min(val, this.currentMax - this.step);
    this.currentMin = val;
    console.log(val)
    this.minValueChange.emit(val);
    this.rangeChange.emit({ min: val, max: this.currentMax });
    this.updatePercentages();
  }

  onMaxDrag(event: Event): void {
    let val = Number((event.target as HTMLInputElement).value);
    val = Math.max(val, this.currentMin + this.step);
    this.currentMax = val;
    this.maxValueChange.emit(val);
    this.rangeChange.emit({ min: this.currentMin, max: val });
    this.updatePercentages();
  }

  private updatePercentages(): void {
    const totalRange = this.max - this.min;
    if (this.isDual) {
      this.minPercent = ((this.currentMin - this.min) / totalRange) * 100;
      this.maxPercent = ((this.currentMax - this.min) / totalRange) * 100;
    } else {
      this.singlePercent = ((this.currentSingle - this.min) / totalRange) * 100;
    }
  }

  format(val: number): string {
    if (this.unit.includes('£')) {
      return '£' + val.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    return val.toLocaleString() + this.unit;
  }

}
